module.exports = __webpack_public_path__ + "static/media/Minerva-McGonagall.64cd452e.jpg";